import {GridSeeker, RadioGroupSeeker, TextFieldSeeker} from "ui-seeker/core"
import React from "react"
import {useContextSelector} from "use-context-selector";
import {AppCalendarEventsContext} from "../../Providers";
import i18n from 'i18n'


export default function EventCreationForm({ updateForm }) {
    const formData = useContextSelector(AppCalendarEventsContext, ({ state }) => state.formData)
    const { title, description, relevance } = formData
    const sliderMarks = [
        { value: '1', label: i18n.t('common:events.priorityLow') },
        { value: '2', label: i18n.t('common:events.priorityMedium') },
        { value: '3', label: i18n.t('common:events.priorityHigh') }
    ]
    return <>
        <GridSeeker size={12} className="event-name">
            <TextFieldSeeker id="title" value={title} label={i18n.t('common:fields.name')} variant="standard" onChange={e => updateForm({ title: e.target.value })} />
        </GridSeeker>
        <GridSeeker size={12} className="event-description">
            <TextFieldSeeker id="description" value={description} label={i18n.t('common:fields.description')} variant="standard" onChange={e => updateForm({ description: e.target.value })} />
        </GridSeeker>
        <GridSeeker size={12} className="date-type">
            <RadioGroupSeeker dataRadioGroup={sliderMarks} formLabel={i18n.t('common:events.relevance')} defaultValue={relevance.toString()} onChange={e => updateForm({ relevance: e.target.value })} />
        </GridSeeker>
    </>
}